export default {
  rowTitleStyles: {
    fontSize: 14
  },
  rowContainerStyles: {
    marginTop: 0,
    marginBottom: 0
  }
};